import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';

const thehippieshakeUsSizeOptions = [
  'UK6 / US2',
  'UK8 / US4',
  'UK10 / US6',
  'UK12 / US8',
  'UK14 / US10',
  'UK16/ US12',
  'UK18 / US14',
  'UK20 / US16',
  'UK22 / US18',
  'UK24 / US 20',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'S/M',
  'M/L',
  'ONE SIZE',
  'Shoe - UK4 / US6',
  'Shoe - UK5 / US7',
  'Shoe - UK6 / US8',
  'Shoe - UK7 / US9',
  'Shoe - UK8 / US10',
  'Shoe - UK9 / US11',
];

const allSizeVariantOptionNames = ['size', 'shoe size'];

const thehippieshakeUsConditionsOptions = [
  {
    key: Conditions.NewWithTags,
    label: 'New Condition',
    shortLabel: 'New',
    description: 'The item has never been worn.',
  },
  {
    key: Conditions.Excellent,
    label: 'Excellent Condition',
    shortLabel: 'Excellent',
    description:
      'Your item has only been lightly used and has been extremely well maintained. There may be some small signs of wear, but nothing major.',
  },
  {
    key: Conditions.Good,
    label: 'Good Condition',
    shortLabel: 'Good',
    description:
      'The item has been worn and it’s well maintained. There may be some quirks like a small stain, a button missing, or a loose thread, but it’s overall in good shape.',
  },
];

export const thehippieshakeUsShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({
      options: thehippieshakeUsConditionsOptions,
    }),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: thehippieshakeUsSizeOptions }),
  ],
  allSizeVariantOptionNames,
};
